<div class="content">
  <ciao-user-profile-form
    [personId]="personId$ | async"
  ></ciao-user-profile-form>
  <hr />
  <ciao-user-profile-teams-table
    [personId]="personId$ | async"
  ></ciao-user-profile-teams-table>
</div>
